export function getCookie(name) {
  console.log("🔍 getCookie called with name:", name);

  // DEV MODE
  if (process.env.REACT_APP_ENVIRONMENT === "development") {
    console.log("🟢 ENV: development");
    const devToken =
      "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2FwaS5hcHAubWF3YWxvZy5jb20vdjEuMy9sb2dpbiIsImlhdCI6MTc3MTUwOTcwOSwiZXhwIjoxNzcxNTk2MTA5LCJuYmYiOjE3NzE1MDk3MDksImp0aSI6IklMYWRKQ2ZkTHVIc1Y0bFgiLCJzdWIiOiIxMjMyIiwicHJ2IjoiOWFkNTg1NzdmYWI2ZmJjMTU1NDM0ZDM1OTFlZGYxNjRhMTc3NjVhYSIsImF1dGhpZCI6MTIzMiwib3JnaWQiOjEwNSwidXNlcmlkIjoxMjMyLCJkYXRhYmFzZW5hbWUiOiJtYXdhbG9nb25lIiwib3JnX2NvZGUiOiJtYXdhbG9nb25lIiwidGltZXpvbmUiOiIgKyBpbnRlcnZhbCAnMDUgaG91cnMgMzAgbWludXRlcyciLCJyb2xlaWQiOjQ5NywicGF5bWVudF9zdGF0dXMiOnRydWUsImF1dGhvcml0aWVzIjpbIlJPTEVfVVNFUiJdLCJkZXZpY2VfaWQiOiJiOTAzMmY0OS01ZTQwLTRmNTMtOTBlOS1lN2IzN2E3Y2YwYmUifQ.vXY1s4jOt_orUaMbhfT1yDikpEnAPf1cpnJvaoPG0-g";
    console.log("✅ Returning DEV token");
    return devToken;
  }

  // PROD MODE
  console.log("🟡 ENV: production");
  const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;
  console.log("🔗 Accounts URL:", accountsUrl);

  const cookieString = document.cookie;
  console.log("🍪 document.cookie:", cookieString);

  const cookies = cookieString.split(";");
  console.log("📦 Parsed cookies:", cookies);

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim();
    console.log(`➡️ Checking cookie[${i}]:`, cookie);

    if (cookie.startsWith(name + "=")) {
      const value = cookie.substring(name.length + 1);
      console.log("🎯 Cookie matched:", name);
      console.log("🔑 Cookie value:", value);

      if (!value) {
        console.warn("⚠️ Cookie value empty, redirecting...");
        window.location.href = accountsUrl;
      }

      return value;
    }
  }

  console.error("❌ Cookie not found, redirecting to login");

  document.cookie =
    "redirectPath=" + window.location.href + "; path=/; domain=.mawalog.com";
  document.cookie = "mawalog=; path=/; domain=.mawalog.com";

  window.location.href = accountsUrl;
  return null;
}

export function header() {
  const token = getCookie("mawalog");

  console.log(token);
  return {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
    Accept: "application/json",
    ...(token && { Authorization: token }),
  };
}
